import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Flex } from "@appsmith/wds";
import styles from "./styles.module.css";
import { CHAT_LIST_PADDING } from "./constants";

interface ChatMessageListContainerProps {
  children: React.ReactNode;
  messagesDirection: "column" | "column-reverse";
}

export interface ChatMessageListContainerRef {
  scrollToBottom: () => void;
}

export const ChatMessageListContainer = forwardRef<
  ChatMessageListContainerRef,
  ChatMessageListContainerProps
>((props, ref) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => ({
    scrollToBottom: () => {
      containerRef.current?.scrollTo({
        behavior: "smooth",
        top: containerRef.current?.scrollHeight,
      });
    },
  }));

  return (
    <div
      aria-label="Chat messages"
      className={styles.messageList}
      data-testid="t--ai-chat-message-list-container"
      ref={containerRef}
      role="list"
    >
      <Flex
        direction={props.messagesDirection}
        flexGrow={1}
        gap="spacing-6"
        padding="spacing-4"
        paddingLeft={CHAT_LIST_PADDING}
        paddingRight={CHAT_LIST_PADDING}
      >
        {props.children}
      </Flex>
    </div>
  );
});
